import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import loadable from '@loadable/component';
import { Typography } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import { calcMeetingStatus } from '../common/portalConfig';
import PreMeeting from './PreMeeting';
import PostMeeting from './PostMeeting';
// import ChimeMeeting from '../../ChimeMeeting';
import AuthGuard from '../auth/AuthGuard';
const ChimeMeeting = loadable(() => import('../../ChimeMeeting'));
const REGISTRATION_ERROR = 'REGISTRATION_ERROR';
const PERMISSIONS_ERROR = 'PERMISSIONS_ERROR';
const Meeting = ({ meetingKey, settings, }) => {
    const store = useStore();
    const { currentCustomer, currentRegistration, getMeetingRegistration, getOrLoad, load, } = store;
    const meeting = getOrLoad('meeting', meetingKey);
    const registration = currentRegistration;
    const { meeting: registrationMeeting } = registration || {};
    const isCurrentRegistrationMatchCurrentMeeting = !!registrationMeeting && (registrationMeeting?.id === meeting?.id);
    const { registrationRequired } = meeting;
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (!currentCustomer) {
            // User is not authenticated, no need to load data
            setIsLoading(false);
            return;
        }
        let isMounted = true;
        const loadData = async () => {
            try {
                setIsLoading(true);
                console.log('loadData is called');
                await load('meeting', meetingKey, 15);
                await getMeetingRegistration(meetingKey);
                if (isMounted) {
                    setError(null);
                }
            }
            catch (err) {
                const isRegistrationError = err?.errors?.some((e) => e?.message?.includes('Registration not found'));
                const isPermissionsError = err?.errors?.some((e) => e?.message?.includes('You Do Not Have Access to This Meeting'));
                console.log('Error during loadData:', { err, isRegistrationError, isPermissionsError });
                if (isMounted) {
                    const errorMessage = err instanceof Error
                        ? err.message
                        : 'An error occurred while fetching registration.';
                    if (isPermissionsError) {
                        setError(PERMISSIONS_ERROR);
                    }
                    else if (isRegistrationError) {
                        setError(REGISTRATION_ERROR);
                    }
                    else {
                        setError(errorMessage);
                    }
                }
            }
            finally {
                setIsLoading(false);
            }
        };
        loadData();
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCustomer]);
    if (isLoading) {
        return _jsx("div", {});
    }
    if (error && error !== REGISTRATION_ERROR) {
        if (error === PERMISSIONS_ERROR) {
            return (_jsx("div", { style: { textAlign: 'center', marginTop: '2rem' }, children: _jsx(Typography, { variant: "h5", style: { fontSize: '24pt', color: 'black' }, children: "You do not have access to this meeting." }) }));
        }
        return (_jsx("div", { style: { textAlign: 'center', marginTop: '2rem' }, children: _jsxs(Typography, { variant: "body1", color: "error", children: [error, isCurrentRegistrationMatchCurrentMeeting && 'Not Matching meeting and registration'] }) }));
    }
    const meetingStatus = calcMeetingStatus(meeting);
    let meetingContent;
    if (meetingStatus === 'ACTIVE' && !registrationRequired) {
        meetingContent = _jsx(ChimeMeeting, { meeting: meeting, registration: registration });
    }
    else if (meetingStatus === 'PRE_MEETING'
        || meetingStatus === 'OPEN'
        || meetingStatus === 'ACTIVE') {
        meetingContent = _jsx(PreMeeting, { meeting: meeting, settings: settings });
    }
    else if (meetingStatus === 'POST_MEETING') {
        meetingContent = (_jsx(PostMeeting, { meeting: meeting, settings: settings, registration: registration, isLoading: isLoading }));
    }
    else {
        meetingContent = _jsx("div", { children: "Cancelled or unknown" });
    }
    return (_jsx(AuthGuard, { initialTab: "SIGN-IN", header: (_jsx(Typography, { variant: "h5", sx: { p: 3 }, children: "To access this meeting, please sign in or create an account." })), children: meetingContent }));
};
Meeting.defaultProps = {
    settings: undefined,
};
export default observer(Meeting);
//# sourceMappingURL=Meeting.js.map